import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const programRelateSubcategories = `${REACT_APP_API_PREFIX}/${service}/programRelateSubcategories`;

export function getProgramRelateSubcategories(filters) {
  const url = `${programRelateSubcategories}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getProgramRelateSubcategoryById(id) {
  const url = `${programRelateSubcategories}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function getProgramsByProgramSubcategories(id) {
  const url = `${programRelateSubcategories}/${id}/programs`;
  return {
    method: GET,
    url,
  };
}

export function updateProgramRelateSubcategory(id, body) {
  const url = `${programRelateSubcategories}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteProgramRelateSubcategory(id) {
  const url = `${programRelateSubcategories}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createProgramRelateSubcategory(body) {
  const url = `${programRelateSubcategories}`;
  return {
    method: POST,
    url,
    body,
  };
}
